$(document).ready(function(){

    function callback(mutationList, observer) {
        mutationList.forEach( (mutation) => {
            switch(mutation.type) {
              case 'childList':
                mutation.addedNodes.forEach( (node) => {
                    if( node.getAttribute('id') === 'vntbs-wrp-el' ) {
                        $("#vntrust-pci img.needsfocus").attr('alt', 'PCI Logo'); 
                        $("#vntrust-shopify img.needsfocus").attr('alt', 'Shopify Logo'); 
                        $("#vntrust-guarantee img.needsfocus").attr('alt', 'Satisfaction Guarenteed Image'); 
                        $("#vntrust-ssl img.needsfocus").attr('alt', 'SSL Certificate Icon Image'); 
                    }
                 });
                break;
            }
          });
    }

    const targetNode = document.querySelector("body");
    const observerOptions = {
        childList: true,
        attributes: false,
        subtree: false
    }

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, observerOptions);

});
 
